import { C } from '../data/constants.js';

export class Input {
  constructor(canvas) {
    // canvas is the Canvas instance (has .el, .toLogicalX, etc.)
    this.canvas = canvas;
    this.pointerX = C.CANVAS_W / 2;  // logical X of pointer/finger
    this.pointerY = C.CANVAS_H / 2;  // logical Y of pointer/finger
    this.tapX = 0;
    this.tapY = 0;
    this.pointerActive = false;       // is a touch/mouse currently active?
    this.tapped = false;              // was there a tap/click this frame?
    this.keys = {};                   // currently held keys
    this.keyJustPressed = {};         // keys pressed this frame
    this.onTapCallback = null;        // direct synchronous user gesture callback
    this.lastTouchTime = 0;

    this._bindTouch();
    this._bindMouse();
    this._bindKeyboard();
  }

  _bindTouch() {
    const el = this.canvas.el;
    el.addEventListener('touchstart', (e) => {
      e.preventDefault();
      this.lastTouchTime = performance.now();
      const t = e.touches[0];
      this.pointerX = this.canvas.toLogicalX(t.clientX);
      this.pointerY = this.canvas.toLogicalY(t.clientY);
      this.tapX = this.pointerX;
      this.tapY = this.pointerY;
      this.pointerActive = true;
      this.tapped = true;
      if (this.onTapCallback) {
        this.onTapCallback(this.tapX, this.tapY);
      }
    }, { passive: false });

    el.addEventListener('touchmove', (e) => {
      e.preventDefault();
      this.lastTouchTime = performance.now();
      const t = e.touches[0];
      this.pointerX = this.canvas.toLogicalX(t.clientX);
      this.pointerY = this.canvas.toLogicalY(t.clientY);
    }, { passive: false });

    el.addEventListener('touchend', (e) => {
      e.preventDefault();
      this.lastTouchTime = performance.now();
      this.pointerActive = false;
    }, { passive: false });
  }

  _bindMouse() {
    const el = this.canvas.el;
    el.addEventListener('mousemove', (e) => {
      if (performance.now() - this.lastTouchTime < 600) return;
      this.pointerX = this.canvas.toLogicalX(e.clientX);
      this.pointerY = this.canvas.toLogicalY(e.clientY);
      this.pointerActive = true;
    });

    el.addEventListener('mousedown', (e) => {
      if (performance.now() - this.lastTouchTime < 600) return;
      this.tapX = this.canvas.toLogicalX(e.clientX);
      this.tapY = this.canvas.toLogicalY(e.clientY);
      this.tapped = true;
      if (this.onTapCallback) {
        this.onTapCallback(this.tapX, this.tapY);
      }
    });
  }

  _bindKeyboard() {
    window.addEventListener('keydown', (e) => {
      this.keys[e.code] = true;
      this.keyJustPressed[e.code] = true;
    });

    window.addEventListener('keyup', (e) => {
      this.keys[e.code] = false;
    });
  }

  // Call at end of each frame to reset per-frame state
  endFrame() {
    this.tapped = false;
    this.keyJustPressed = {};
  }

  // Convenience methods
  get launchPressed() {
    return this.tapped || this.keyJustPressed['Space'];
  }

  get pausePressed() {
    return this.keyJustPressed['Escape'] || this.keyJustPressed['KeyP'];
  }

  get left() {
    return this.keys['ArrowLeft'];
  }

  get right() {
    return this.keys['ArrowRight'];
  }
}
